import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=45429de1&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=45429de1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45429de1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45429de1')) {
      api.createRecord('45429de1', component.options)
    } else {
      api.reload('45429de1', component.options)
    }
    module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=45429de1&scoped=true&", function () {
      api.rerender('45429de1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Other/TermsAndConditions.vue"
export default component.exports